import { StatusMessage } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';

import { Loader2 } from 'lucide-react';

/**
 * A whole-surface load with no known shape to skeleton.
 *
 * Where the loaded layout IS known — a list of cards, the identity card — use a
 * `Skeleton` in the same layout wrapper instead, so the swap causes no layout
 * shift. A spinner is the fallback, not the default.
 */
function LoadingState({ title, subtitle }) {
  const { t } = useTranslation('unified-profiles');

  return (
    <div data-testid="loading-state" className="flex flex-1 flex-col items-center justify-center" role="status">
      <StatusMessage
        icon={Loader2}
        iconClassName="animate-spin"
        title={title || t('states.loading.title')}
        subtitle={subtitle || t('states.loading.subtitle')}
      />
    </div>
  );
}

export default LoadingState;
